module.exports = __webpack_public_path__ + "img/9.bae6ac2f.jpg";